<div class="position-fixed bottom-0 start-50 translate-middle-x mb-3 floating-bar-container" *ngIf="visible">
  <div class="floating-bar-body d-flex align-items-center justify-content-between gap-2 gap-sm-3 bg-white px-3 py-2 rounded-pill shadow-lg border">
    <div class="text-nowrap text-dark floating-bar-counter">
      <span class="fw-bold">{{ countLabel }} {{ selectedCount }} {{ countUnit }}</span>
    </div>

    <div class="d-flex align-items-center floating-bar-slot">
      <ng-content></ng-content>
    </div>

    <div *ngIf="showClearButton" class="d-flex align-items-center">
      <app-button
        [class]="'btn btn-link text-danger text-decoration-none p-1 m-0 d-inline-flex align-items-center border-0'"
        [spinner]="false"
        [id]="'floating_bar_clear_btn'"
        (click)="onClear()">
        <span class="d-inline-flex align-items-center gap-1 lh-1">
          <i class="ri-close-line fs-6 lh-1"></i>
          <span class="clear-btn-text">{{ clearLabel }}</span>
        </span>
      </app-button>
    </div>
  </div>
</div>
